import * as React from 'react';

import { AppMainPage, AppSeoPage } from '@pages';
import { inject, observer } from 'mobx-react';

import { EStore } from '@enums';

import { fetchData, commonWillUnmount } from '@decorators';

import { IAppState } from '@stores';

import { IAppPageProps, IMatchAppPageParams } from './types';

@inject(
	EStore.APP,
	EStore.COUNTERS,
	EStore.CURRENT_USER,
	EStore.MAIN_MENU_APPS,
)
@observer
@commonWillUnmount()
@fetchData([
	async ({ appStore, currentUserStore }: IAppState, { appId }: IMatchAppPageParams) =>
		currentUserStore.isUserAuth && appStore.fetchActiveApp(appId),
])
export class AppPage extends React.PureComponent<IAppPageProps> {

	render() {
		const { appStore, currentUserStore } = this.props;

		if (!currentUserStore.isUserAuth) {
			return React.createElement(AppSeoPage);
		}

		if (!appStore.activeApp) {
			return null;
		}

		if (appStore.activeApp.useJSAPI === false) {
			window.location.replace(appStore.activeApp.url);
			return null;
		}

		return React.createElement(AppMainPage);
	}

}
